<template>
  <li
    class="accordion__item"
    :class="{'opened': accordionOpened && !disabled}"
  >
    <component
      :is="headlineLevel"
      :id="`accordion__header--${accordionId}`"
      class="accordion__header sr-only"
    >{{ title }}</component>
    <slot name="accordion-header__prepend" />
    <button
      :ref="`accordion-button-${accordionId}`"
      :aria-controls="`accordion__body--${accordionId}`"
      :aria-expanded="`${accordionOpened}`"
      :class="{
        'opened': accordionOpened && !disabled,
        'active': (accordionOpened || active) && !disabled,
        'button--disabled': disabled
      }"
      :disabled="disabled"
      class="accordion__button"
      type="button"
      @click="toggleAccordion"
    >
      <span
        v-if="icon !== undefined"
        class="icon-container"
      >
        <svg-icon
          :class="'icon-' + icon"
          :name="icon"
          aria-hidden="true"
          focusable="false"
        />
      </span>
      <span
        v-if="accordionButtonText"
        class="accordion__text"
      >{{ accordionButtonText }}</span>
      <slot name="accordion-header" />
      <span
        v-if="!disabled"
        class="accordion__toggle-icon"
      >
        <svg-icon
          :name="'chevron-down'"
          class="'icon-chevron-down"
          aria-hidden="true"
          focusable="false"
        />
      </span>
    </button>
    <transition
      name="accordion__body--"
      @before-enter="beforeEnter"
      @enter="enter"
      @after-enter="afterEnter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <div
        v-show="accordionOpened"
        :id="`accordion__body--${accordionId}`"
        :aria-labelledby="`accordion__header--${accordionId}`"
        :class="{'accordion__body--visible': accordionOpened}"
        class="accordion__body"
      >
        <div
          class="accordion__content"
          :class="{'accordion__content--no-padding': noContentPadding}"
        >
          <slot name="accordion-content" />
        </div>
      </div>
    </transition>
  </li>
</template>

<script>
export default {
  name: 'AccordionItem',
  props: {
    headlineLevel: {
      type: String,
      required: true
    },
    accordionButtonText: {
      type: String,
      default: undefined
    },
    accordionButtonLabel: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: undefined
    },
    opened: {
      type: Boolean,
      default: false
    },
    noContentPadding: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    closeOthers: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      accordionId: new Date().getTime(),
      accordionOpened: false
    }
  },
  watch: {
    opened (newValue) {
      if (this.closeOthers) {
        if (newValue === false) {
          this.accordionOpened = false
          this.$emit('close')
        } else {
          this.accordionOpened = true
          this.$emit('open')
        }
      }
    }
  },
  mounted () {
    // if (this.active) {
    //   this.$refs[`accordion-button-${this.accordionId}`].focus()
    // }

    if (this.opened) {
      this.accordionOpened = this.opened
    }
  },
  methods: {
    toggleAccordion () {
      this.$emit('accordion-click')

      if (!this.closeOthers) {
        this.accordionOpened = !this.accordionOpened

        if (this.accordionOpened) {
          this.$emit('open')
        } else {
          this.$emit('close')
        }
      }
    },
    beforeEnter (accordionBody) {
      accordionBody.style.height = '0'
    },
    enter (accordionBody) {
      accordionBody.style.height = accordionBody.scrollHeight + 'px'
    },
    afterEnter (accordionBody) {
      accordionBody.style.height = 'auto'
    },
    beforeLeave (accordionBody) {
      accordionBody.style.height = accordionBody.scrollHeight + 'px'
    },
    leave (accordionBody) {
      setTimeout(() => {
        accordionBody.style.height = '0'
      }, 100)
    }
  }
}
</script>
